// extracted by mini-css-extract-plugin
module.exports = {"LoaderContainer":"CarouselImagePlaceholder_LoaderContainer__1yEf2"};